export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10498.f45d2c67.jpg";